// =============================================================================
// Task #2323 — friendly user-facing Email Express polish errors.
// -----------------------------------------------------------------------------
// Raw provider errors ("kie.ai task <id> failed: <failCode> <failMsg>", HTTP
// statuses, socket errors, missing API keys, …) are technical noise for the
// user. The polish worker keeps the FULL raw message in server logs / Sentry
// but stores this friendly message in `polishError` / per-block `renderError`
// and in failure notifications. The client uses the SAME classifier to heal
// previously-stored raw errors on read, so keep this the single cross-runtime
// source of truth — server and browser must never drift.
// Messages that are already user-appropriate (e.g. "image service repeatedly
// failed: N of M block(s) could not be rendered") pass through untouched.
// =============================================================================

export const FRIENDLY_POLISH_ERROR =
  "Image generation hit a temporary issue. Please try again.";

// Mirrors the worker's transient/rejection families (isTransientKieFailure /
// isRenderRejection) plus raw provider/infra shapes: kie.ai task strings, HTTP
// statuses, fetch/socket failures, auth/misconfiguration, JSON parse noise.
const RAW_PROVIDER_ERROR_RE =
  /kie\.ai\b|failCode|failMsg|\bHTTP \d{3}\b|fetch image failed|fetch image returned|unexpected token|json parse|api[ _]?key|unauthoriz|forbidden\b|content polic|content[_-]?policy|safety system|moderation|may violate|violate[^.]*polic|not allowed|disallowed|inappropriate|task rejected|1200000400|could not be processed|cannot be processed|revise your input|timed out|time out|temporar|internal server|server error|bad gateway|gateway time|service unavailable|\b(429|500|502|503|504)\b|rate limit|overload|fetch failed|socket|econnreset|network/i;

export function looksLikeRawProviderError(message: string): boolean {
  return RAW_PROVIDER_ERROR_RE.test(message);
}

export function friendlyPolishError(message: string): string {
  return looksLikeRawProviderError(message) ? FRIENDLY_POLISH_ERROR : message;
}

// Read-side heal for the client: previously-failed emails may still carry raw
// provider text stored before the worker sanitized at the sink.
export function friendlyPolishErrorText(
  msg: string | null | undefined,
): string {
  if (!msg) return "";
  return friendlyPolishError(msg);
}
